export enum StreamSplitType {
    NoSplit = 0,
    TopHorisontalSplit = 1,
    BottomHorisontalSplit = 2,
    LeftVerticalSplit = 3,
    RightVerticalSplit = 4,
    TopLeftSplit = 5,
    TopRightSplit = 6,
    BottomLeftSplit = 7,
    BottomRightSplit = 8,
}
